<template>
    <div style="font-size: 0;">
        <Header />
        <img class="banner-img" style="margin-top: 3.4rem" src="../../../public/img/contactus/head_img.jpg">
        <div class="content">
            <h6 class="title_g" style="padding-top: 2rem">CONTACT US</h6>
            <div class="infos">
                <h1>Ningbo Globalway Imp. & Exp. Co., Ltd.</h1>
                <div><b>Phone:</b> <span>+86-574-89012968</span></div>
                <div><b>Fax:</b> <span>+86-574-87313473</span></div>
                <div><b>Email:</b> <span>info@globalwayhome.com</span></div>
                <div><b>Address:</b><br><span>1701 Hengdagao Mansion, 1016 South Qianhe Road, Shounan Street, Yinzhou District, Ningbo, Zhejiang Province, China</span></div>
                <img class="wechat" src="../../../public/img/wechat.png">
                <p>Any enquiry or question, please contact us.<br />Thank you!</p>
            </div>
        </div>
        <img class="introduce" src="../../../public/img/contactus/introduce.jpg" alt="">
    </div>
</template>

<script>
import Header from '@/layout/header.vue';

export default {
    name: 'ContactUs',
    components: { Header }
}
</script>

<style lang="less" scoped>
    .content { background-color: #f7f5f6; position: relative; padding: 0 1rem 1.5rem; }
    .introduce { width: 100%; }
    .infos { position: relative; padding-top: .6rem; font-size: 1rem; text-align: center; }
    .infos > * { margin-bottom: .8rem; }
    .infos b { font-size: .8rem; }
    .infos span { color: #565455; font-size: .8rem; }
    .wechat { height: 6rem; object-fit: contain; padding-top: .6rem; }
</style>